module.exports = __webpack_public_path__ + "static/media/image_xanhNhat.b1bec182.png";